import React, { useEffect } from "react";
import { useAuth } from "@/lib/AuthContext";

export default function SignIn() {
  const { login, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      login();
    }
  }, [isAuthenticated]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#0a0a0a" }}>
      <div className="w-8 h-8 border-4 border-transparent rounded-full animate-spin" style={{ borderTopColor: "#c8f135" }} />
    </div>
  );
}
